import { CacheKeys } from '~/components/atoms/cache-keys';

export const removeCacheKeys = () => {
  Object.values(CacheKeys).map((value) => {
    try {
      sessionStorage.removeItem(value);
    } catch (err) {
      //TODO: Send to AppInsights error information
      console.log(err);
    }
  });
};
